import { textInput } from '@utils/component-framework';
import { NoSSR } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useTaskContext } from '../../context.js';
import { useInputState } from '../../hook.use-input-state.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { TextInput } from './atom.text-input.js';
import { shouldHaveGroup, stateBox } from './input.text.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function WriteAnswersTextInput(props) {
  const context = useTaskContext();
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => textInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = evt => {
    update(props.taskEntryKey, props.node.id, {
      type: "text",
      value: evt.currentTarget.value
    });
  };
  const state = useInputState(props.node, inputEntry);
  const shouldHaveValue = props.node.validation.correctAnswers.find(answer => textInput.cleanText(answer, props.node.validation) !== textInput.cleanText(inputEntry?.value ?? "", props.node.validation));
  if (state !== "input" && (props.node.containingWord?.prefix || props.node.containingWord?.suffix)) {
    return /*#__PURE__*/jsxs("span", {
      className: shouldHaveGroup,
      children: [/*#__PURE__*/jsxs(StateBox, {
        state: state,
        textTheme: "colored",
        withShadow: true,
        className: stateBox,
        children: [props.node.containingWord?.prefix && /*#__PURE__*/jsx("span", {
          children: props.node.containingWord?.prefix
        }), /*#__PURE__*/jsx("span", {
          children: inputEntry?.value
        }), props.node.containingWord?.suffix && /*#__PURE__*/jsx("span", {
          children: props.node.containingWord?.suffix
        })]
      }), state === "incorrect" && /*#__PURE__*/jsxs(StateBox, {
        state: "should-have",
        textTheme: "colored",
        withShadow: true,
        className: stateBox,
        children: [props.node.containingWord?.prefix && /*#__PURE__*/jsx("span", {
          children: props.node.containingWord?.prefix
        }), /*#__PURE__*/jsx("span", {
          children: shouldHaveValue
        }), props.node.containingWord?.suffix && /*#__PURE__*/jsx("span", {
          children: props.node.containingWord?.suffix
        })]
      })]
    });
  }
  const minLength = Math.max(props.isOnlyInput ? 7 : 0, props.node.styling.extendSizeBy);
  return /*#__PURE__*/jsx(NoSSR, {
    children: /*#__PURE__*/jsxs("span", {
      className: shouldHaveGroup,
      children: [props.node.containingWord?.prefix && /*#__PURE__*/jsx("span", {
        children: props.node.containingWord?.prefix
      }), /*#__PURE__*/jsx(TextInput, {
        value: inputEntry?.value,
        state: state,
        theme: props.node.containingWord ? "thin" : "regular",
        enterKeyHint: props.isLastInput ? "done" : "next",
        minimumInputLength: minLength,
        readOnly: context === "facit" || context === "readonly",
        onChange: onChange,
        height: "small"
      }), props.node.containingWord?.suffix && /*#__PURE__*/jsx("span", {
        children: props.node.containingWord?.suffix
      }), state === "incorrect" && /*#__PURE__*/jsx(TextInput, {
        value: shouldHaveValue,
        state: "should-have",
        readOnly: true,
        minimumInputLength: minLength,
        height: "small"
      })]
    })
  });
}

export { WriteAnswersTextInput };
//# sourceMappingURL=input.text.js.map
